/**
 * ADR 0007: shared primitives are unstyled — every look lives under its area. This carries
 * `type="button"` (so a stray button never submits a form) and the cursor, nothing else.
 *
 * Deliberately no `bg-transparent`, `p-0` or `border-0` here: those are utility classes, so
 * they sit at the same specificity as a caller's `bg-…` or `px-…` and the winner is decided by
 * the order Tailwind happens to emit them in, not by the order they are written. That is what
 * stripped the background and padding off the checkpoint's answer buttons. Tailwind's preflight
 * already neutralises a button's user-agent background, padding and border at *element*
 * specificity, which every caller utility beats cleanly.
 */

import type { ButtonHTMLAttributes, Ref } from "react";

export function Button({
  className = "",
  type = "button",
  ref,
  ...props
}: ButtonHTMLAttributes<HTMLButtonElement> & { ref?: Ref<HTMLButtonElement> }) {
  return (
    <button
      ref={ref}
      type={type}
      className={"cursor-pointer disabled:cursor-default " + className}
      {...props}
    />
  );
}
